document.addEventListener('DOMContentLoaded', () => {
  function hideEmptyRelatedProductsSection(section) {
    if (!section) return;
    section.style.display = 'none';
  }

  document.querySelectorAll('.shopify-section--related-products').forEach((section) => {
    const slides = section.querySelectorAll('.rs-related-products .swiper-slide');
    if (slides.length === 0) {
      hideEmptyRelatedProductsSection(section);
    }
  });

  function labelSlides(swiper) {
    const slides = swiper.slides;
    if (!slides) return;
    const total = slides.length;
    slides.forEach((slide, index) => {
      slide.setAttribute('aria-label', window.__t('slide_of', { current: index + 1, total: total }));
    });
  }

  function updateSlideVisibility(swiper) {
    const slides = swiper.slides;
    if (!slides) return;
    const activeIndex = swiper.activeIndex || 0;
    const perView = getPerView(swiper);
    slides.forEach((slide, index) => {
      const isVisible = index >= activeIndex && index < activeIndex + perView;
      if (isVisible) {
        slide.removeAttribute('inert');
        slide.setAttribute('aria-hidden', 'false');
      } else {
        slide.setAttribute('inert', '');
        slide.setAttribute('aria-hidden', 'true');
      }
    });
  }

  function refreshAccessibility(swiper) {
    labelSlides(swiper);
    updateSlideVisibility(swiper);
  }

  function getPerView(swiper) {
    if (swiper.params.slidesPerView === 'auto') {
      return typeof swiper.slidesPerViewDynamic === 'function' ? swiper.slidesPerViewDynamic() : 1;
    }
    return Math.round(swiper.params.slidesPerView) || 1;
  }

  function getVisibleTabbables(swiper) {
    const activeIndex = swiper.activeIndex || 0;
    const perView = getPerView(swiper);
    const result = [];
    for (let i = activeIndex; i < activeIndex + perView && i < swiper.slides.length; i++) {
      const slide = swiper.slides[i];
      slide.querySelectorAll('*').forEach(el => {
        if (
          (el.matches('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled])') ||
          (el.hasAttribute('tabindex') && el.getAttribute('tabindex') !== '-1'))
        ) {
          if (el.type === 'hidden') return;
          if (el.offsetParent === null && !el.matches('[tabindex]')) return;
          const style = window.getComputedStyle(el);
          if (style.visibility === 'hidden' || style.display === 'none' || style.opacity === '0') return;
          if (el.offsetWidth === 0 && el.offsetHeight === 0 && !el.matches('[tabindex]')) return;
          result.push(el);
        }
      });
    }
    return result;
  }

  const carousels = document.querySelectorAll(
    '.rs-best-sellers [data-slider]:not(.swiper-initialized), .rs-related-products [data-slider]:not(.swiper-initialized)'
  );
  carousels.forEach(carousel => {
    const container = carousel.parentElement;
    const section = carousel.closest('.rs-best-sellers, .rs-related-products') || container;
    const wrapper = carousel.querySelector('.swiper-wrapper');
    if (section?.classList.contains('rs-related-products') && !wrapper?.querySelector('.swiper-slide')) {
      hideEmptyRelatedProductsSection(section.closest('.shopify-section'));
      return;
    }
    const nextBtn = container?.querySelector('.swiper-button-next');
    const prevBtn = container?.querySelector('.swiper-button-prev');
    const paginationEl = container?.querySelector('.fraction-indicator');

    // The valid transform value. Only updated when WE initiate a slide change.
    // Any other transform change (from Swiper reacting to inert) gets reverted.
    let validTransform = '';
    let allowTransformChange = false;

    function authorizeTransform() {
      allowTransformChange = true;
    }

    function captureTransform(swiperInstance) {
      if (wrapper) validTransform = wrapper.style.transform;
      allowTransformChange = false;
      updateSlideVisibility(swiperInstance);
    }

    const swiper = new Swiper(carousel, {
      slidesPerView: 'auto',
      spaceBetween: 16,
      slidesPerGroup: 1,
      watchOverflow: true,
      a11y: false,
      keyboard: false,
      ...(nextBtn && prevBtn
        ? {
            navigation: {
              nextEl: nextBtn,
              prevEl: prevBtn,
            },
          }
        : {}),
      ...(paginationEl
        ? {
            pagination: {
              el: paginationEl,
              type: 'fraction',
            },
          }
        : {}),
      on: {
        init: function () {
          // Capture the initial transform (should be 0)
          validTransform = wrapper ? wrapper.style.transform : '';
          // Defer inert so Swiper init is complete
          setTimeout(() => {
            authorizeTransform();
            this.update();
            refreshAccessibility(this);
            captureTransform(this);
          }, 0);
        },
        resize: function () {
          authorizeTransform();
          this.update();
          updateSlideVisibility(this);
          captureTransform(this);
        },
        touchStart: function () {
          authorizeTransform();
        },
        touchEnd: function () {
          setTimeout(() => captureTransform(this), 350);
        },
        navigationNext: authorizeTransform,
        navigationPrev: authorizeTransform,
        slideChangeTransitionStart: authorizeTransform,
        slideChangeTransitionEnd: function () {
          captureTransform(this);
        },
        slideChange: function () {
          if (!this.params.speed) {
            captureTransform(this);
          }
        },
      },
    });

    // MutationObserver: revert any unauthorized transform changes
    if (wrapper) {
      const observer = new MutationObserver(() => {
        if (!allowTransformChange && wrapper.style.transform !== validTransform) {
          wrapper.style.transform = validTransform;
        }
      });
      observer.observe(wrapper, { attributes: true, attributeFilter: ['style'] });
    }

    // Authorize before Swiper's navigation handler runs.
    if (nextBtn) {
      nextBtn.addEventListener('click', authorizeTransform, { capture: true });
    }
    if (prevBtn) {
      prevBtn.addEventListener('click', authorizeTransform, { capture: true });
    }

    /**
     * Advance carousel by one slide for Tab navigation.
     */
    function tabAdvance(direction, callback) {
      authorizeTransform();

      if (direction === 'next') {
        swiper.slideNext(0);
      } else {
        swiper.slidePrev(0);
      }

      captureTransform(swiper);

      // Wait for any internal Swiper rAF reactions to fire and get blocked
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (wrapper) wrapper.style.transform = validTransform;
          callback();
        });
      });
    }

    section?.addEventListener('keydown', (e) => {
      if (e.key !== 'Tab') return;

      const active = document.activeElement;
      const isShift = e.shiftKey;
      const isInCarousel = carousel.contains(active);

      if (!isInCarousel) return;

      const tabbables = getVisibleTabbables(swiper);
      if (tabbables.length === 0) return;

      let currentIndex = tabbables.indexOf(active);
      if (currentIndex === -1) {
        currentIndex = tabbables.findIndex(el => el.contains(active) || active.contains(el));
      }
      if (currentIndex === -1) {
        for (let i = 0; i < tabbables.length; i++) {
          const pos = active.compareDocumentPosition(tabbables[i]);
          if (pos & Node.DOCUMENT_POSITION_FOLLOWING) {
            currentIndex = isShift ? i : i - 1;
            break;
          }
        }
        if (currentIndex === -1) {
          currentIndex = tabbables.length - 1;
        }
      }

      const activeSlideIndex = swiper.activeIndex || 0;
      const perView = getPerView(swiper);
      const totalSlides = swiper.slides.length;
      const isAtEnd = activeSlideIndex + perView >= totalSlides;
      const isAtStart = activeSlideIndex === 0;

      if (!isShift) {
        if (currentIndex === tabbables.length - 1 && !isAtEnd) {
          e.preventDefault();
          tabAdvance('next', () => {
            const newTabbables = getVisibleTabbables(swiper);
            const newLastSlideIndex = Math.min(swiper.activeIndex + getPerView(swiper) - 1, swiper.slides.length - 1);
            const newLastSlide = swiper.slides[newLastSlideIndex];
            if (newLastSlide) {
              const firstInNew = newTabbables.find(el => newLastSlide.contains(el));
              if (firstInNew) firstInNew.focus({ preventScroll: true });
            }
          });
        }
        // else: let browser handle Tab naturally, inert blocks off-screen focus
      } else {
        if (currentIndex === 0 && !isAtStart) {
          e.preventDefault();
          tabAdvance('prev', () => {
            const newTabbables = getVisibleTabbables(swiper);
            const newFirstSlide = swiper.slides[swiper.activeIndex];
            if (newFirstSlide) {
              const lastInNew = [...newTabbables].reverse().find(el => newFirstSlide.contains(el));
              if (lastInNew) lastInNew.focus({ preventScroll: true });
            }
          });
        }
      }
    });

    carousel._removeSlideAndRefresh = function (slideEl) {
      const index = Array.from(swiper.slides).indexOf(slideEl);
      if (index !== -1) {
        authorizeTransform();
        swiper.removeSlide(index);
        captureTransform(swiper);
        refreshAccessibility(swiper);
      }
    };
  });
});
